import { Box, Button, Text } from '@chakra-ui/react';

import { useAnalytics } from '@r-client/shared/data/analytics';

import backgroundDesktop from './assets/back@2x.jpg';
import backgroundMobile from './assets/back-xs.jpg';

export function FilmBanner() {
  const analytics = useAnalytics();

  const onBannerClick = () => {
    analytics.track({
      name: 'promo_flash_banner_clicked',
      params: {
        label: 'xprize_banner',
      },
    });
  };

  return (
    <Box
      as="a"
      href="/xprize"
      display="grid"
      gap="8px 16px"
      gridTemplateColumns={{ sm: '1fr auto 1fr' }}
      alignItems="center"
      p={{ base: '12px 16px' }}
      color="white"
      textAlign="center"
      overflow="hidden"
      backgroundColor="black"
      backgroundImage={{
        base: backgroundMobile,
        sm: backgroundDesktop,
      }}
      backgroundSize={{ base: 'cover', sm: 'auto 100%' }}
      backgroundPosition="50% 0"
      backgroundRepeat="no-repeat"
      onClick={onBannerClick}
    >
      <Box
        display="flex"
        gridColumnStart={{ sm: 2 }}
        alignItems="center"
        justifyContent="center"
        gap="12px"
      >
        <Text
          fontSize="16px"
          letterSpacing="-0.24px"
          size="republic-default"
          variant="republic-default"
          maxW={{ base: '320px', sm: 'none' }}
        >
          Republic Film + Future Vision XPRIZE: invest in the optimistic vision
          of tomorrow
        </Text>
      </Box>
      <Box justifySelf={{ sm: 'right' }}>
        <Button
          display="block"
          backgroundColor="transparent"
          as="span"
          color="white"
          p={{ base: '7px 12px', md: '7px 48px' }}
          height="auto"
          borderRadius="3px"
          fontSize="sm-md"
          fontWeight="600"
          lineHeight="21px"
          boxShadow="inset 0 0 0 1px rgba(255,255,255,0.4)"
          _hover={{
            color: 'inherit',
            backgroundColor: 'grey.900',
          }}
          variant="republic-default"
          size="md"
        >
          Details
        </Button>
      </Box>
    </Box>
  );
}
